import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { PartnerPagesModule } from './partnerpages/partnerpages.module';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { HeaderComponent } from './partnerpages/header/header.component';
import { AuthService } from './services/auth.service';
import { PartnerModule } from './partner/partner.module';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AmbulanceTrackingComponent } from './ambulance-tracking/ambulance-tracking.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ArticlesComponent } from './articles/articles.component';
import { CustomminDirective } from './directives/custommin.directive';
import { CustommaxDirective } from './directives/custommax.directive';
import { DatePipe } from '@angular/common';
import { UserOrdersComponent } from './user-orders/user-orders.component';
import { BlogDetailComponent } from './blog-detail/blog-detail.component';
import { EditProfileComponent } from './edit-profile/edit-profile.component';
import { TagInputModule } from 'ngx-chips';
import { ChatComponent } from './chat/chat.component';
import { PatientComponent } from './patient/patient.component';
import { RazorpayComponent } from './razorpay/razorpay.component';
import { MedicalTourismComponent } from './components/medical-tourism/medical-tourism.component';
import { LinksComponent } from './links/links.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Atricles2Component } from './atricles2/atricles2.component';
import { BlogDetail2Component } from './blog-detail2/blog-detail2.component';
import { ClipboardModule } from 'ngx-clipboard';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ShareTrackingComponent } from './share-tracking/share-tracking.component';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { ChatBotComponent } from './chat-bot/chat-bot.component';
import { UserPlansComponent } from './user-plans/user-plans.component';
import { UserWalletComponent } from './user-wallet/user-wallet.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PromocodeChatComponent } from './chat-bot/promocode-chat/promocode-chat.component';
import { UserNotificationsComponent } from './user-notifications/user-notifications.component';

// Translate
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';

// Firebase v9 modular
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';
import { environment } from '../environments/environment';

// Local replacement modules
import { SlideshowModule } from './shared/slideshow/slideshow.module';
import { Ng2TelInputModule } from './shared/ng2-tel-compat/ng2-tel-input.module';
import { AmazingTimePickerModule } from './shared/time-picker-compat/amazing-time-picker.module';
import { ShareButtonsModule } from './shared/share-buttons/share-buttons.module';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    UserProfileComponent,
    AmbulanceTrackingComponent,
    ArticlesComponent,
    CustomminDirective,
    CustommaxDirective,
    UserOrdersComponent,
    BlogDetailComponent,
    EditProfileComponent,
    ChatComponent,
    PatientComponent,
    RazorpayComponent,
    MedicalTourismComponent,
    LinksComponent,
    PrivacyComponent,
    Atricles2Component,
    BlogDetail2Component,
    ShareTrackingComponent,
    ChatBotComponent,
    UserPlansComponent,
    UserWalletComponent,
    PromocodeChatComponent,
    UserNotificationsComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),

    // Firebase v9
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideMessaging(() => getMessaging()),

    PartnerModule,
    PartnerPagesModule,
    AmazingTimePickerModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SlickCarouselModule,
    GooglePlaceModule,
    GoogleMapsModule,
    TagInputModule,
    TabsModule.forRoot(),
    TimepickerModule.forRoot(),
    Ng2TelInputModule,
    SlideshowModule,
    ShareButtonsModule,
    FontAwesomeModule,
    ClipboardModule,
    NgxSpinnerModule,
    ModalModule.forRoot(),
    CarouselModule,
    ToastrModule.forRoot({ positionClass: 'toast-bottom-right', preventDuplicates: true }),
    TranslateModule.forRoot({
      loader: { provide: TranslateLoader, useFactory: HttpLoaderFactory, deps: [HttpClient] }
    }),
  ],
  providers: [AuthService, DatePipe],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
